import React, { useRef } from "react";
import { motion } from "framer-motion";

const roadmapSteps = [
  {
    title: "Phase 1",
    description: "Launch of the Koon project and initial marketing.",
    steps: [
      "Fair Launch without premint for fair distribution",
      "Building the first community base via social networks and crypto platforms",
      "Development of a supportive community: 'The People’s Cat'",
      "Goal: Become the DOG KILLER by surpassing major dog tokens like Dogecoin and Shiba Inu",
      "Aspire to be the first cat token to dominate the crypto leaderboard",
    ],
  },
  {
    title: "Phase 2",
    description: "Charity engagement and increasing visibility.",
    steps: [
      "Launch of cat photo contests and giveaways",
      "CEX listing campaign to expand visibility",
      "Rembursement of veterinary bills for those in need",
      "Integration of AI Chatbot to provide real-time project updates",
      "Raising awareness about animal issues and promoting transparency",
    ],
  },
  {
    title: "Phase 3",
    description: "Gamification, CEX listings, and NFT collection.",
    steps: [
      "Launch of the game 'Claws vs Tokens' to protect cat tokens and eliminate dog tokens",
      "Development of marketing strategies to grow the Koon community",
      "NFT collection representing rescued animals and their impact",
      "Exclusive giveaways, including the chance to win a purebred cat",
    ],
  },
  {
    title: "Phase 4",
    description: "Long-term impact and community continuity.",
    steps: [
      "Develop partnerships with charities and businesses to support animal welfare",
      "Organize events and meetups to engage the community",
      "Expand the Koon ecosystem with new projects and applications",
      "Create new NFT collections, games, and initiatives",
    ],
  },
];

function Roadmap() {
  const scrollContainer = useRef(null);

  const scroll = (direction) => {
    const scrollAmount = direction === "left" ? -450 : 450;
    scrollContainer.current.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div id="roadmap" className="roadmap section">
      <img
        src="./images/roadmap_bg.png"
        alt="Koon race"
        className="koon_roadmap"
      />
      <svg
        className="roadmap_wave"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill="#1eae94"
          fill-opacity="1"
          d="M0,192L80,197.3C160,203,320,213,480,202.7C640,192,800,160,960,170.7C1120,181,1280,235,1360,261.3L1440,288L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
        ></path>
      </svg>

      <svg
        className="roadmap_wave_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill="#333333"
          fill-opacity="1"
          d="M0,128L80,128C160,128,320,128,480,112C640,96,800,64,960,53.3C1120,43,1280,53,1360,58.7L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
        ></path>
      </svg>
      <div className="title">
        <h1>Roadmap</h1>
        <img src="/images/claw_title.png" alt="Claw" className="claw-title" />
      </div>
      <div className="roadmap-path-wrapper">
        <div className="roadmap-path" ref={scrollContainer}>
          {roadmapSteps.map((step, index) => (
            <motion.div
              className="roadmap-step"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="step_bg">
                <img src={`/images/roadmap_step_${index + 1}.jpg`} alt="" />
              </div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <ul>
                  {step.steps.map((subStep, subIndex) => (
                    <li key={subIndex}>{subStep}</li>
                  ))}
                </ul>
              </div>
              <div className="checkpoint" />
              {index < roadmapSteps.length - 1 && (
                <div className="connecting-line" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
      <div className="container mx-auto roadmap-controls">
        <button onClick={() => scroll("left")} className="scroll-btn left">
          &lt;
        </button>
        <button onClick={() => scroll("right")} className="scroll-btn right">
          &gt;
        </button>
      </div>
    </div>
  );
}

export default Roadmap;
